import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/config/i18n'
import '@/plugins/axios'
import { createProvider, apolloClient } from '@/plugins/vue-apollo'
import '@/plugins/fontawesome'
import '@/plugins/vee-validate'
import '@/plugins/vue-filter'
import '@/plugins/vue-toasted'
import '@/plugins/vue-js-modal'
import '@/assets/styles/main.scss'
import { initApolloClientAccessor } from '@/packages/ApolloClientAccessor'
import factory from '@/handler'

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  const handler = factory(err)
  const errorBag = handler(err)
  store.dispatch('errors/set', errorBag.all())

  if (process.env.NODE_ENV !== 'production') {
    console.log('[ERROR]', err, vm, info)
  }
}

initApolloClientAccessor(apolloClient)

new Vue({
  router,
  store,
  i18n,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount('#app')
